import type { Participant } from '@seen/core/models/patients/participant'
import { createContext } from 'react'

export const CurrentParticipantContext = createContext<Participant | null>(null)
